import { useState, useEffect } from "react";
import ConnectWallet from "../components/ConnectWallet";
import Bubble from "../components/coral/Bubble";
import CoralLeftType2 from "../components/coral/CoralLeftType2";
import CoralRightType2 from "../components/coral/CoralRightType2";
import CustomButton from "../components/CustomButton";
import Loading from "../components/Loading";
import Menu from "../components/Menu";
import ScrollTop from "../components/ScrollTop";
import { registerInvestor } from "../services/api";

export default function RegisterInvestor() {
  const [name, setName] = useState("");
  const [organization, setOrganization] = useState("");
  const [country, setCountry] = useState("");
  const [projects, setProjects] = useState("");
  const [amount, setAmount] = useState("");
  const [help, setHelp] = useState("");
  const [channel, setChannel] = useState("");
  const [memberCountry, setMemberCountry] = useState("");
  const [memberNumber, setMemberNumber] = useState("");
  const [contact, setContact] = useState("");
  const [know, setKnow] = useState("");

  const [errorMessage, setErrorMessage] = useState(false);
  const [successMessage, setSuccessMessage] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  function submitForm() {
    if (
      name === "" ||
      organization === "" ||
      country === "" ||
      projects === "" ||
      amount === "" ||
      help === "" ||
      channel === "" ||
      memberCountry === "" ||
      memberNumber === "" ||
      contact === "" ||
      know === ""
    ) {
      setSuccessMessage(false);
      setErrorMessage(true);
    } else {
      setErrorMessage(false);
      const content = [
        {
          question: "What is your name?",
          answer: name,
        },
        {
          question:
            "Please tell us a short introduction about your organization.",
          answer: organization,
        },
        {
          question: "Which country are you based in?",
          answer: country,
        },
        {
          question:
            "What are the portfolio/projects you have worked with before?",
          answer: projects,
        },
        {
          question: "What is your estimated investment amount?",
          answer: amount,
        },
        {
          question: "How would you be able to help us develop Sharktopia?",
          answer: help,
        },
        {
          question:
            "What are your community/social media channels links? (we might require the official accounts to send us messages later to prove you own it)",
          answer: channel,
        },
        {
          question:
            "Which countries/areas are your prominent community members from?",
          answer: memberCountry,
        },
        {
          question:
            "How many members can you think you can bring to our community?",
          answer: memberNumber,
        },
        {
          question: "What is your contact info: Telegram/Email/Twitter?",
          answer: contact,
        },
        {
          question: "How did you know about us?",
          answer: know,
        },
      ];
      registerInvestor(
        name,
        contact,
        "Register Investor Form",
        JSON.stringify(content)
      ).then((result) => {
        if (result.success) {
          setSuccessMessage(true);
          resetForm();
        }
      });
    }
  }

  function resetForm() {
    setName("");
    setOrganization("");
    setCountry("");
    setProjects("");
    setAmount("");
    setHelp("");
    setChannel("");
    setMemberCountry("");
    setMemberNumber("");
    setContact("");
    setKnow("");
  }

  return (
    <div className="pageContainer registerInvestorContainer">
      <Menu />
      <ScrollTop />
      <ConnectWallet />
      <Loading loading={loading} />
      <CoralLeftType2 />
      <CoralRightType2 />
      <Bubble top={"200px"} />

      <div className="content">
        <div className="pageTitle">INVESTOR REGISTRATION FORM</div>
        <div className="registerForm">
          <div className="field">
            <div className="label">1. What is your name?</div>
            <div className="inputField inputSmall">
              <input value={name} onChange={(e) => setName(e.target.value)} />
            </div>
          </div>

          <div className="field">
            <div className="label">
              2. Please tell us a short introduction about your organization.
            </div>
            <div className="inputField inputBig">
              {/* <input value={organization} onChange={(e) => setOrganization(e.target.value)}/> */}
              <textarea
                value={organization}
                onChange={(e) => setOrganization(e.target.value)}
              />
            </div>
          </div>

          <div className="field">
            <div className="label">3. Which country are you based in?</div>
            <div className="inputField inputSmall">
              <input
                value={country}
                onChange={(e) => setCountry(e.target.value)}
              />
            </div>
          </div>

          <div className="field">
            <div className="label">
              4. What are the portfolio/projects you have worked with before?
            </div>
            <div className="inputField inputBig">
              {/* <input value={projects} onChange={(e) => setProjects(e.target.value)}/> */}
              <textarea
                value={projects}
                onChange={(e) => setProjects(e.target.value)}
              />
            </div>
          </div>

          <div className="field">
            <div className="label">
              5. What is your estimated investment amount?
            </div>
            <div className="inputField inputSmall">
              <input
                value={amount}
                onChange={(e) => setAmount(e.target.value)}
              />
            </div>
          </div>

          <div className="field">
            <div className="label">
              6. How would you be able to help us develop Sharktopia?
            </div>
            <div className="inputField inputSmall">
              <input value={help} onChange={(e) => setHelp(e.target.value)} />
            </div>
          </div>

          <div className="field">
            <div className="label">
              7. What are your community/social media channels links? (we might
              require the official accounts to send us messages later to prove
              you own it)
            </div>
            <div className="inputField inputSmall">
              <input
                value={channel}
                onChange={(e) => setChannel(e.target.value)}
              />
            </div>
          </div>

          <div className="field">
            <div className="label">
              8. Which countries/areas are your prominent community members
              from?
            </div>
            <div className="inputField inputSmall">
              <input
                value={memberCountry}
                onChange={(e) => setMemberCountry(e.target.value)}
              />
            </div>
          </div>

          <div className="field">
            <div className="label">
              9. How many members can you think you can bring to our community?
            </div>
            <div className="inputField inputSmall">
              <input
                value={memberNumber}
                onChange={(e) => setMemberNumber(e.target.value)}
              />
            </div>
          </div>

          <div className="field">
            <div className="label">
              10. What is your contact info: Telegram/Email/Twitter?
            </div>
            <div className="inputField inputSmall">
              <input
                value={contact}
                onChange={(e) => setContact(e.target.value)}
              />
            </div>
          </div>

          <div className="field">
            <div className="label">11. How did you know about us?</div>
            <div className="inputField inputBig">
              {/* <input value={know} onChange={(e) => setKnow(e.target.value)}/> */}
              <textarea
                value={know}
                onChange={(e) => setKnow(e.target.value)}
              />
            </div>
          </div>
        </div>

        {errorMessage ? (
          <div className="footerDescription errorMessage">
            Please, fill all fields in the form above! Thank you
          </div>
        ) : (
          ""
        )}

        {successMessage ? (
          <div className="footerDescription">
            Thank you for your interest in Sharktopia. We will contact you soon
            after verifying the information.
          </div>
        ) : (
          ""
        )}

        <div className="footerBtn">
          <CustomButton
            text={"SUBMIT"}
            textColor={"black"}
            fn={submitForm}
            type={"small"}
            transparent={false}
          />
        </div>
      </div>

      <div className="footer">
        <Bubble bottom={"5%"} />
        <div className="footerBrand">@Sharktopia 2021</div>
      </div>
    </div>
  );
}
